import { render, staticRenderFns } from "./serviceIndex.vue?vue&type=template&id=4bb42a99&scoped=true&"
import script from "./serviceIndex.vue?vue&type=script&lang=js&"
export * from "./serviceIndex.vue?vue&type=script&lang=js&"
import style0 from "./serviceIndex.vue?vue&type=style&index=0&id=4bb42a99&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb42a99",
  null
  
)

export default component.exports